export default function forEach(iterable, callback) {
    let index = 0;
    for (const item of iterable) {
        const value = callback(item, index);
        if (value === false) {
            break;
        }
        index++;
    }
}
